module.exports = __webpack_public_path__ + "static/media/brand_large_banner.859ae081.jpg";